import { render } from "./LessonPopups.vue?vue&type=template&id=737c5476"
import script from "./LessonPopups.vue?vue&type=script&lang=js"
export * from "./LessonPopups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__